// Shared constants for the AAWTA marketing site
export const AAWTA = {
  logoUrl:
    'https://customer-assets-agu9un31.emergentagent.net/job_aawta-summit-hub/artifacts/rh9va6fe_statonary%20design%20AAWTA%20Logo_1-100%20%281%29%20%281%29.jpg',
  flyerUrl:
    'https://customer-assets-agu9un31.emergentagent.net/job_aawta-summit-hub/artifacts/whpl8s1z_landscap%20workforce.png',
  agendaPdfUrl:
    'https://customer-assets-agu9un31.emergentagent.net/job_aawta-summit-hub/artifacts/kajrp88c_AAWTA_2026_Workforce_Summit_Agenda.pdf',
  exhibitorFloorPlanUrl: 'https://canva.link/m05achlskuriof5',
  // Summit start (Sep 17, 2026, 8:00 AM ET) & end (5:00 PM ET). Countdown component uses UTC offsets.
  summitStartIso: '2026-09-17T12:00:00Z', // 08:00 EDT = 12:00 UTC
  summitEndIso: '2026-09-17T21:00:00Z',   // 17:00 EDT = 21:00 UTC
  eventDate: 'September 17, 2026',
  eventTime: '8:00 AM – 5:00 PM',
  eventLocation: 'Stone Mountain, GA',
  venueName: 'Stone Ridge Event Center',
  venueAddress: '1750 Stone Ridge Drive, Suite A, Stone Mountain, GA 30083',
  address: '5269 Buford Highway, Doraville, GA 30340',
  phone: '(770) 756-6768',
  phoneRaw: '+17707566768',
  email: 'Contact@aawta.org',
  calendarUrl: 'https://aawta-hub.emergent.host/book/nicole-2',
  website: 'https://www.aawta.org',
  pitchDeckUrl:
    'https://gamma.app/docs/AAWTA-Education-Industry-Workforce-Collaborative-8x6qp65qf236swg',
  // Sponsorship / Exhibitor / Investment guides (single combined PDF today; will split when separate files arrive)
  corporateSponsorshipGuideUrl:
    'https://customer-assets-agu9un31.emergentagent.net/job_aawta-summit-hub/artifacts/e2077n4m_Corporate%20Sponsorship%20%26%20Investment%20Guide%20%281%29.pdf',
  exhibitorGuideUrl:
    'https://customer-assets-agu9un31.emergentagent.net/job_aawta-summit-hub/artifacts/e2077n4m_Corporate%20Sponsorship%20%26%20Investment%20Guide%20%281%29.pdf',
  speakerGuideUrl:
    'https://customer-assets-agu9un31.emergentagent.net/job_aawta-summit-hub/artifacts/j5ddrc6a_2026%20Speaker%2C%20Panelist%2C%20Roundtable%20Facilitator%20%26%20Breakout%20Session%20Guide%20%281%29.pdf',
  imAttendingCanvaUrl: 'https://canva.link/2ex2fog9avaf4eh',
  // Public-facing Zeffy pages (open in new tab)
  zeffySponsorUrl:
    'https://www.zeffy.com/en-US/ticketing/aawta-education-and-industry-workforce-collaborative',
  // Zeffy handles AAWTA donations
  zeffyDonateUrl:
    'https://www.zeffy.com/en-US/ticketing/aawta-education-and-industry-workforce-collaborative',
  // Zeffy embed source (used inside iframe)
  zeffyUrl:
    'https://www.zeffy.com/embed/ticketing/aawta-education-and-industry-workforce-collaborative',
  eventbriteUrl:
    'https://www.eventbrite.com/e/youre-invited-building-pathways-creating-opportunities-driving-change-tickets-1994403759332?aff=oddtdtcreator&keep_tld=true',
  hilton: {
    bookingUrl:
      'https://www.hilton.com/en/attend-my-event/atlladt-91f-99c6599f-2269-48ee-831d-d3fea422149d/',
    hotelName: 'DoubleTree by Hilton Atlanta - Northlake',
    address: '4156 LaVista Road, Atlanta, GA 30084',
    phone: '770-938-1026',
    phoneRaw: '+17709381026',
    rate: '$119',
    dates: 'September 16–18, 2026',
    bookByDate: 'September 4, 2026',
    distanceLabel: 'Approximately 7 miles · 15-minute drive to Summit venue',
    exteriorImageUrl:
      'https://customer-assets-agu9un31.emergentagent.net/job_aawta-summit-hub/artifacts/9o5w3ry1_images.jfif',
    roomImageUrl:
      'https://customer-assets-agu9un31.emergentagent.net/job_aawta-summit-hub/artifacts/d8n1gwpp_DoubleTree.png',
  },
  venueImageUrl:
    'https://customer-assets-agu9un31.emergentagent.net/job_aawta-summit-hub/artifacts/72vtpk03_f0df9a38-40cf-45d7-8626-85d683144ba7~sc_675.webp',
  engineUrl: 'https://engine.com/partner/aawta',
  social: {
    facebook: 'https://www.facebook.com/AfricanAmericanWomenInTrucking',
    instagram: 'https://www.instagram.com/aawta_org',
    linkedin:
      'https://www.linkedin.com/company/african-american-women-trucking-association/',
    youtube: 'https://www.youtube.com/channel/UCMjGaJ07C5qsujyvncJwL-w',
  },
};

export const SPONSORSHIP_TIERS = [
  {
    slug: 'presenting-partner',
    name: 'Presenting Partner',
    price: '$20,000',
    availability: 'Exclusive',
    highlight: true,
    icon: 'Gem',
    tagline: 'The signature investment. Named recognition across every touchpoint.',
    features: [
      'Founding Partner recognition',
      'Premier logo placement (website, program, signage)',
      'Opening remarks speaking opportunity',
      'Premium exhibit booth',
      '10 complimentary registrations',
      'VIP Leadership Reception access',
      'Full-page ad in event program',
      'Recognition at Power to Drive Change Gala',
    ],
  },
  {
    slug: 'workforce-champion',
    name: 'Workforce Champion',
    price: '$10,000',
    availability: '2 available',
    icon: 'Star',
    tagline: 'A leadership seat for organizations shaping the future workforce.',
    features: [
      'Founding Partner recognition',
      'Premium logo placement',
      'Panel speaking opportunity',
      'Premium exhibit booth',
      '8 complimentary registrations',
      'VIP Leadership Reception access',
      'Full-page ad in event program',
      'Gala recognition',
    ],
  },
  {
    slug: 'innovation-partner',
    name: 'Innovation Partner',
    price: '$5,000',
    availability: '4 available',
    icon: 'Lightbulb',
    tagline: 'Fuel new pathways in logistics, education, and workforce technology.',
    features: [
      'Founding Partner recognition',
      'Prominent logo placement',
      'Exhibit booth',
      '6 complimentary registrations',
      'VIP Leadership Reception access',
      'Half-page ad in event program',
      'Post-event impact report recognition',
    ],
  },
  {
    slug: 'education-partner',
    name: 'Education Partner',
    price: '$2,500',
    availability: '8 available',
    icon: 'GraduationCap',
    tagline: 'Invest directly in students, educators, and career pathways.',
    features: [
      'Founding Partner recognition',
      'Standard logo placement',
      'Exhibit table',
      '4 complimentary registrations',
      'Quarter-page ad in event program',
      'Social media & newsletter recognition',
    ],
  },
  {
    slug: 'community-partner',
    name: 'Community Partner',
    price: '$1,000',
    availability: 'Unlimited',
    icon: 'HeartHandshake',
    tagline: 'Stand with community organizations driving local impact.',
    features: [
      'Founding Partner recognition',
      'Standard logo placement',
      'Shared exhibit table',
      '2 complimentary registrations',
      'Name listing in event program',
      'Social media & newsletter recognition',
    ],
  },
];

// Full detailed agenda from the finalized PDF
export const AGENDA = [
  { time: '8:00 AM – 9:00 AM', title: 'Registration, Breakfast & Networking', tag: 'Arrival', icon: 'Coffee' },
  { time: '9:00 AM – 9:30 AM', title: 'Welcome', subtitle: 'Official Host Johnique Taylor and Co-Host Nicole Ward, President of AAWTA', tag: 'Opening', icon: 'Sparkles' },
  { time: '9:30 AM – 9:45 AM', title: 'Opening Keynote', subtitle: 'Dr. Kim Estep, Western Governors University', tag: 'Keynote', icon: 'Mic2' },
  { time: '9:45 AM – 10:00 AM', title: 'Raffle Time — Prize Drawing #1', tag: 'Raffle', icon: 'Gift' },
  { time: '10:00 AM – 10:45 AM', title: 'Education & Industry Panel 1', tag: 'Panel', icon: 'Users2' },
  { time: '10:45 AM – 11:00 AM', title: 'Break', tag: 'Break', icon: 'Coffee' },
  { time: '11:00 AM – 11:45 AM', title: 'Workforce Development Panel 2', subtitle: 'Includes Blue Tiger USA Audience Giveaway', tag: 'Panel', icon: 'Users2' },
  { time: '11:45 AM – 12:30 PM', title: 'Partner & Program Spotlight', tag: 'Showcase', icon: 'Star' },
  { time: '12:30 PM – 1:30 PM', title: 'Networking Lunch', tag: 'Networking', icon: 'Utensils' },
  { time: '1:30 PM – 2:30 PM', title: 'Breakout Sessions', tag: 'Working Session', icon: 'LayoutGrid' },
  { time: '2:30 PM – 3:00 PM', title: 'Roundtables', tag: 'Working Session', icon: 'MessagesSquare' },
  { time: '3:00 PM – 3:10 PM', title: 'Raffle Time — Prize Drawing #2', tag: 'Raffle', icon: 'Gift' },
  { time: '3:10 PM – 3:20 PM', title: 'Closing Keynote', subtitle: 'Kristin Hall, BedRock Consulting Services', tag: 'Keynote', icon: 'Mic2' },
  { time: '3:20 PM – 3:30 PM', title: 'Closing Remarks', tag: 'Closing', icon: 'Sparkles' },
  { time: '3:30 PM – 4:30 PM', title: 'Ballroom Open — Exhibitors', subtitle: 'Concurrent with the VIP Reception below', tag: 'Networking', icon: 'Store', concurrent: true },
  { time: '3:30 PM – 5:00 PM', title: 'Exclusive VIP Reception — Optional', subtitle: 'Concurrent with the Ballroom Open above', tag: 'Reception', icon: 'PartyPopper', concurrent: true },
];

export const FAQ_ITEMS = [
  {
    q: 'When and where is the Summit?',
    a: 'Thursday, September 17, 2026, from 8:00 AM to 5:00 PM at Stone Ridge Event Center, 1750 Stone Ridge Drive, Suite A, Stone Mountain, GA 30083.',
  },
  {
    q: 'How do I register?',
    a: 'Registration is powered by Eventbrite. Use the “Register Now” button anywhere on this page to reserve your seat.',
  },
  {
    q: 'Who should attend?',
    a: 'Education leaders, employers, workforce agencies, government, higher education, economic development, community organizations, and students in transportation, logistics, and supply chain.',
  },
  {
    q: 'Is travel or parking assistance provided?',
    a: 'Complimentary on-site parking is available at the venue. We provide a curated list of nearby partner hotels — inquire in the Venue & Hotels section.',
  },
  {
    q: 'Are there lodging options?',
    a: 'Yes. We work with partner hotels near the venue. Submit a hotel inquiry and our team will follow up with the current partner rate and booking links.',
  },
  {
    q: 'Is the event accessible?',
    a: 'The venue is fully ADA accessible. If you have specific accessibility, dietary, or accommodation requests, please let us know in your registration or via Contact@aawta.org.',
  },
  {
    q: 'How can my organization become a sponsor?',
    a: 'Choose a tier from the Sponsorship section or use the “Become a Sponsor” button to be routed to our Zeffy sponsor portal. Founding Partner recognition is available for early commitments.',
  },
  {
    q: 'Can I exhibit or bring a vendor booth?',
    a: 'Yes — exhibit booths are available at multiple sponsorship tiers, and standalone exhibitor space can be inquired about through our exhibitor form.',
  },
];
